import { useEffect } from 'react';

import type { PdpRefreshExperiment } from 'components/marketplace/property/refresh/release';
import { useObservability } from 'helpers/observability';

type PdpRefreshExposureProps = {
  addressId: string;
  experiment: PdpRefreshExperiment | null | undefined;
  preview: boolean;
};

// One impression per listing and arm. Strict mode remounts the page, and a
// per-instance ref would record the enrollment twice.
const impressedAssignments = new Set<string>();

export function clearPdpRefreshImpressions() {
  impressedAssignments.clear();
}

export const PdpRefreshExposure = ({ addressId, experiment, preview }: PdpRefreshExposureProps) => {
  const { trackJourneyEvent } = useObservability();

  useEffect(() => {
    if (preview || !experiment) return;
    const impressionKey = `${addressId}|${experiment.key}|${experiment.variant}|${experiment.variationId}`;
    if (impressedAssignments.has(impressionKey)) return;
    impressedAssignments.add(impressionKey);
    trackJourneyEvent('experimentation', 'impression', {
      experimentName: experiment.key,
      variant: experiment.variant,
      variationId: experiment.variationId,
      addressToken: addressId,
    });
  }, [addressId, experiment, preview, trackJourneyEvent]);

  return null;
};
